// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2a995ef6","239":"abb9be11","455":"1b8cd734","488":"8b95e4da"}[chunkId] + ".chunk.js";
};